import { mixinPropertyUtils } from 'skypager-util/lib/properties'

module.exports = function(chain, api = {}) {
  return chain
    .invoke('select', 'entity', api)
    .thru(result => mixinPropertyUtils(result, true, true))
}


// WEBPACK FOOTER //
// ./src/selectors/document/active-entity.js